import { useEffect, useRef } from "react";
import { showToast } from "../../../utils/utils";
import {
  EXCEL_MIME_TYPE,
  showToastType
} from "../../../utils/constants/appConstants";
import {
  ALL_INVOICE_BATCH_FILENAME,
  allInvoiceBatchData
} from "../../../locales/en";
import privateAxios from "../../../utils/axiosPrivate";
import { getFundingBatchesDownloadExcelURL } from "../../../utils/constants/apiEndPoints";
import PropTypes from "prop-types";

const AllInvoiceBatchData = ({ onDownloadComplete }) => {
  const hasDownloadedRef = useRef(false);

  useEffect(() => {
    if (hasDownloadedRef.current) return;
    hasDownloadedRef.current = true;

    const handleInvoiceBatchDownload = async () => {
      try {
        const response = await privateAxios.get(
          getFundingBatchesDownloadExcelURL,
          {
            responseType: "arraybuffer"
          }
        );

        let filename = ALL_INVOICE_BATCH_FILENAME;
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match?.[1]) filename = match[1];
        }

        const blob = new Blob([response.data], {
          type: EXCEL_MIME_TYPE
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        showToast(allInvoiceBatchData.errMsg.item1, showToastType.success);
      } catch {
        showToast(allInvoiceBatchData.errMsg.item2, showToastType.error);
        hasDownloadedRef.current = false;
      } finally {
        if (onDownloadComplete) onDownloadComplete();
      }
    };

    handleInvoiceBatchDownload();
  }, [onDownloadComplete]);

  return null;
};
AllInvoiceBatchData.propTypes = {
  onDownloadComplete: PropTypes.func
};

export default AllInvoiceBatchData;
